import styled from "styled-components";
import { colors, styles } from "../utils/theme";
import { Link } from "react-router-dom";
import { transparentize } from "../utils/helperFn";
import { device } from "../utils/breakpoints";

const Button = styled(Link)`
  border-radius: ${styles.btn_border_radius};
  padding: ${({ small }) => (small ? "10px 32px" : "1.2rem 2.6rem")};
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 500;
  transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);
  display: inline-block;
  text-align: center;
  margin-top: 1rem;

  @media ${device.lg} {
    font-size: ${({ small }) => (small ? "14px" : "20px")};
    padding: ${({ small }) => (small ? "12px 38px" : "1.2rem 2.6rem")};
  }
`;

const PrimaryButton = styled(Button)`
  background-color: ${colors.secondary};
  color: #fff;
  margin-right: 10px;

  &:hover,
  &:active,
  &:focus {
    background-color: ${transparentize(colors.secondary, 0.6)};
    color: #fff;
    transform: translateY(-2px) scale(1.015);
    box-shadow: 0 10px 20px rgba(243, 5, 132, 0.3);
  }

  &:active {
    transform: translateY(0) scale(1);
    transition-duration: 0.15s;
  }
`;

const OutlinedButton = styled(Button)`
  background-color: transparent;
  color: ${colors.secondary};
  border: 1px solid ${colors.secondary};

  &:hover,
  &:active,
  &:focus {
    background-color: ${colors.secondary};
    color: #fff;
    transform: translateY(-2px) scale(1.015);
    box-shadow: 0 10px 20px rgba(243, 5, 132, 0.2);
  }

  &:active {
    transform: translateY(0) scale(1);
    transition-duration: 0.15s;
  }
`;

const LinkButton = ({
  type = "primary",
  small = false,
  children,
  ...props
}) => {
  switch (type) {
    case "primary":
      return (
        <PrimaryButton small {...props}>
          {children}
        </PrimaryButton>
      );
    case "outlined":
      return (
        <OutlinedButton small {...props}>
          {children}
        </OutlinedButton>
      );
    default:
      return (
        <PrimaryButton small {...props}>
          {children}
        </PrimaryButton>
      );
  }
};

export default LinkButton;
